/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IConnectionRoom {
        sourceBlockHrefs?: any;
        sinkBlockHrefs?: any;
        id: number;
        href: string;
        name: string;
        creationDate: Date;
        pipes: IPipe[];
        blockHrefs: IConnectionRoomBlock[];
        defaultForOrganizationId: number;
    }

    export interface IConnectionRoomBlock {
        blockHref: string;
        type: string;
        name: string;
    }

    export interface IBlocksNamesMap {
        [key: string]: IConnectionRoomBlock;
    }

    export interface IStreamIdMap {
        [key: number]: number;
    }

    export interface ISelectedBlocks {
        selectedSourceId: number;
        selectedDestinationIds: number[];
    }

    export interface IConnectionsMatrix {
        [key: number]: IConnectionStatusMap;
    }

    export enum IConnectionStatus {
        Connected,
        Free,
        Busy,
    }

    export interface IConnectionStatusMap {
        [key: number]: IConnectionStatus;
    }

    export class ConnectionRoom implements IConnectionRoom {
        public id: number;
        public name: string;
        public href: string;
        public creationDate: Date;
        public pipes: IPipe[];
        public blockHrefs: IConnectionRoomBlock[];
        public defaultForOrganizationId: number;

        public static Empty(): ConnectionRoom {
            return new ConnectionRoom();
        }

        public static getStatusString(connectionStatus: number): string {
            if (connectionStatus === IConnectionStatus.Busy)
                return 'Busy';
            else if (connectionStatus === IConnectionStatus.Connected)
                return 'Connected';
            else if (connectionStatus === IConnectionStatus.Free)
                return 'Free';
            else
                return 'Unknown';
        }

        constructor() {
            // empty constructor
            this.name = '';
            this.pipes = undefined;
            this.blockHrefs = [];
            this.defaultForOrganizationId = undefined;
        }
    }

    export interface IConnRoomTakeHalResult {
        connRoomResource: IHalElement<ConnectionRoom>;
        ok: boolean;
        message: string;
    }

    export class ConnRoomTakeResult {
        constructor(public connRoom: ConnectionRoom,
                    public ok: boolean,
                    public errorMessage: string) {
        }
    }
}
